import React, { Component } from 'react';
import './App.css';

import Mainfront from "./mainfront";

class App extends Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    return (
      <div className="App">
        <Mainfront />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js